export class HttpResponseModel<T> {
    public isSuccessful: boolean;
    public data: T;

    public constructor({isSuccessful, data}: {isSuccessful: boolean, data: T}) {
        this.isSuccessful = isSuccessful;
        this.data = data;
    }
}